import React from "react";
import Heading from "./heading.jsx";

const Card = ({
  children,
  className = "",
  divided = false,
  header,
  padding = "p-4 sm:p-6",
  border = true,
  shadow = true,
  ...props
}) => {
  return (
    <div
      className={`${border ? "border" : ""} ${shadow ? "shadow-md" : ""} bg-surface h-fit ${className}`.trim()}
      {...props}
    >
      {header && (
        <Heading sx="py-4 px-3" size="text-md">
          {header}
        </Heading>
      )}
      {divided ? (
        React.Children.map(children, (child, index) => (
          <>
            {index > 0 && <hr className="border-border-subtle" />}
            <div className="p-6">{child}</div>
          </>
        ))
      ) : (
        <div className={`${padding}`}>{children}</div>
      )}
    </div>
  );
};

export default Card;
